import { Field, FieldProps, useFormikContext } from 'formik';
import { FormattedDate, FormattedMessage, FormattedNumber } from 'react-intl';
import { Grid } from '@mui/material';
import { PoolFormikNumberTextfield } from '@synergy/components-next';
import { PoolTextField, PoolTypography } from '@synergy/components';
import { fields } from '@synergy/utils';

import { CustomerConditionsFormValues } from '../models/customer-conditions-form-values';
import { CustomerDetailConditionsFact } from './customer-detail-conditions-fact';
import { TaxRateAutocomplete } from '../../../../../../common/components/tax-rate-autocomplete/tax-rate-autocomplete';
import { customerConditionSelector } from '../store/customer-conditions-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

export const CustomerDetailConditionsBonus = () => {
    const formik = useFormikContext<CustomerConditionsFormValues>();
    const { conditions } = useAppSelector(customerConditionSelector);

    const fieldNames = fields<CustomerConditionsFormValues>();

    return (
        <Grid container={true} spacing={2}>
            <Grid item={true} xs={12}>
                <PoolTypography
                    sx={{ mb: 1 }}
                    styleType="sectionTitleNew"
                    id="app.contactsAndOrganizations.conditions.bonus"
                />
            </Grid>
            <Grid item={true} xs={4}>
                <Field name="bonusBase">
                    {({ field, meta }: FieldProps<number>) => (
                        <PoolTextField
                            isNumeric={true}
                            minDecimalScale={2}
                            label={<FormattedMessage id="app.contactsAndOrganizations.conditions.bonus.bonusBase" />}
                            fullWidth={true}
                            suffix={' %'}
                            error={!!meta.touched && !!meta.error}
                            helperText={meta.touched && meta.error ? <FormattedMessage id={meta.error} /> : null}
                            required={formik.values.isMember}
                            disabled={!formik.values.isMember}
                            {...field}
                        />
                    )}
                </Field>
            </Grid>
            <Grid item={true} xs={4}>
                <PoolFormikNumberTextfield
                    minDecimalScale={2}
                    name="bonusPayout"
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.bonus.bonusPayout" />}
                    fullWidth={true}
                    suffix={' %'}
                    disabled={!formik.values.isMember}
                />
            </Grid>
            <Grid item={true} xs={4}>
                <TaxRateAutocomplete
                    name={fieldNames.ledgerAccountId}
                    useId={true}
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.ledgerAccount" />}
                    required={formik.values.isMember}
                    disabled={!formik.values.isMember}
                />
            </Grid>
            <Grid item={true} xs={4}>
                {/* Date and amount of the last credit note a bonus settlement
                    booked for this member — what they actually received. */}
                <CustomerDetailConditionsFact
                    label={<FormattedMessage id="app.contactsAndOrganizations.conditions.lastBonusPayout" />}
                    empty={null == conditions?.lastBonusPayoutAmount || !conditions?.lastBonusPayoutDate}
                >
                    {null != conditions?.lastBonusPayoutAmount && conditions?.lastBonusPayoutDate && (
                        <>
                            <FormattedDate
                                value={conditions.lastBonusPayoutDate}
                                day="2-digit"
                                month="2-digit"
                                year="numeric"
                            />
                            {' · '}
                            <FormattedNumber value={conditions.lastBonusPayoutAmount} style="currency" currency="EUR" />
                        </>
                    )}
                </CustomerDetailConditionsFact>
            </Grid>
        </Grid>
    );
};
